export type AutomatorState = {
  loading: boolean;
  newProjectModal: boolean;
  dataUpdated: boolean;
  appFunctions: { search?: string; limit?: number; offset?: number };
  appsData: {
    data: {
      id: number;
      name: string;
      description: string;
      username: string;
      workflow_status: string;
      workflow_trigger_type: string;
    }[];
    total_data?: number;
  };
  updatePageAsPerSearch: { my_projects: boolean };
};

export type AutomatorAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_NEW_PROJECT_MODAL'; payload: boolean }
  | { type: 'SET_DATA_UPDATED'; payload: boolean }
  | { type: 'SET_APP_FUNCTIONS'; payload: { search?: string; limit?: number; offset?: number } }
  | {
      type: 'SET_APPS_DATA';
      payload: {
        data: {
          id: number;
          name: string;
          description: string;
          username: string;
          workflow_status: string;
          workflow_trigger_type: string;
        }[];
        total_data?: number;
      };
    }
  | { type: 'SET_UPDATE_PAGE_SEARCH'; payload: { my_projects: boolean } };

export const AutomatorReducer = (
  state: AutomatorState,
  action: AutomatorAction,
): AutomatorState => {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_NEW_PROJECT_MODAL':
      return { ...state, newProjectModal: action.payload };
    case 'SET_DATA_UPDATED':
      return { ...state, dataUpdated: action.payload as boolean };
    case 'SET_APP_FUNCTIONS':
      return {
        ...state,
        appFunctions: { ...state.appFunctions, ...action.payload },
      };
    case 'SET_APPS_DATA':
      return { ...state, appsData: action.payload };
    case 'SET_UPDATE_PAGE_SEARCH':
      return { ...state, updatePageAsPerSearch: action.payload };
    default:
      return state;
  }
};
